import ContentPageLayout from 'components/ContentPageLayout'

const ContactUs = (): JSX.Element => {
	return <ContentPageLayout contentKey="contactus" />
}

export default ContactUs
